/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */
import { Button, FormControl, InputLabel, MenuItem, Select } from '@material-ui/core';
import { Form as _Form, useFormik, FormikConfig, FormikContextType } from 'formik';
import React, { ReactNode, useEffect } from 'react';
import { CancelButton, SubmitButton } from '../Button';
import TextInput from '../TextField';
import SecureInput from '../TextField/SecureInput';

export interface InputType {
    type: 'email' | 'select' | 'checkbox' | 'text' | 'password';
    label: string;
    name: string;
    component?: any;
    extraProps?: object;
    multiline?: boolean;
    disabled?: boolean;
    value?: string;
}
export interface ExtraFormPropsTypes {
    submitButtonLabel?: string;
    buttonExtraActions?: boolean;
    isCancel?: boolean;
    onCancel?: React.MouseEventHandler;
    cancelButtonLabel?: string;
}
export interface FormPropType extends ExtraFormPropsTypes {
    ui: Partial<InputType>[];
}
export interface FormikPropType extends FormPropType {
    formik: FormikContextType<any>;
    children?: ReactNode;
    parentClass?: string;
}

const Selector = ({ formik, value, ...props }: InputType & any) => {
    let component = null;
    switch (props.type) {
        case 'email':
        case 'text': {
            component = (
                <>
                    <TextInput
                        value={
                            props.name === 'pan' || props.name === 'userId'
                                ? (value || '').toUpperCase()
                                : props.name === 'mobile'
                                    ? (value || '').replace(/\D/g, '')
                                    : value
                        }
                        disabled={formik.isSubmitting}
                        fullWidth
                        {...props}
                    />
                </>
            );
            break;
        }
        case 'password': {
            component = <SecureInput disabled={formik.isSubmitting} {...props} />;
            break;
        }
        default: {
            component = <h3>{`${props.type} not found`}</h3>;
        }
    }
    return component;
};

function Form({
    ui = [],
    submitButtonLabel = '',
    buttonExtraActions = false,
    isCancel = false,
    onCancel,
    cancelButtonLabel = 'Cancel',
    formik,
    parentClass = '',
    ...props
}: FormikPropType): JSX.Element {
    return (
        <>
            <form className={parentClass} onSubmit={formik.handleSubmit}>
                {ui.map(
                    (
                        { component: Component, extraProps = {}, ..._ele }: Partial<InputType>,
                        index: Number,
                    ) => {
                        const fieldProps = {
                            key: index + 'field',
                            onChange: formik.handleChange,
                            value: formik.values[`${_ele.name}`],
                            error:
                                formik.touched[`${_ele.name}`] &&
                                Boolean(formik.errors[`${_ele.name}`]),
                            helperText:
                                formik.touched[`${_ele.name}`] && formik.errors[`${_ele.name}`],
                        };
                        return !!Component ? (
                            <Component
                                updateValue={(value: string) =>
                                    formik.setFieldValue(_ele.name || '', value)
                                }
                                value={formik.values[`${_ele.name}`]}
                                formik={formik}
                                {..._ele}
                                {...extraProps}
                            />
                        ) : (
                            <>
                                <Selector {...extraProps} {...fieldProps} {..._ele} formik={formik} />
                                {(_ele.name === "userId" || _ele.name === 'pan' || _ele.name === 'pekrn') && 
                                    <div style={{ marginBottom: '16px', marginTop: '-10px' }}>
                                        <a 
                                            className="pan-link" 
                                            href="https://www.onlineservices.nsdl.com/paam/endUserRegisterContact.html" 
                                            target="_blank"
                                        > 
                                            Click here to apply for PAN
                                        </a>
                                    </div>
                                }
                            </>
                        );
                    },
                )}
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                    }}
                    className="buttons"
                >
                    {submitButtonLabel && (
                        <>
                            {formik.isSubmitting ? (
                                <Button fullWidth className="customBtn">
                                    Sending
                                    <span className="sending-dots">
                                        <i></i>
                                        <i></i>
                                        <i></i>
                                    </span>
                                </Button>
                            ) : (
                                <SubmitButton
                                    type="submit"
                                    label={submitButtonLabel}
                                    id="submit-id"
                                    disabled={formik.isSubmitting}
                                />
                            )}
                        </>
                    )}
                    {isCancel && (
                        <CancelButton
                            label={cancelButtonLabel}
                            id="cancel-id"
                            disabled={formik.isSubmitting}
                            style={{ marginLeft: 10 }}
                            onClick={onCancel}
                        />
                    )}
                </div>
                {props.children}
            </form>
        </>
    );
}

export default Form;
